/**
 * Created by akirilyuk on 2/9/18.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/createCaseSubViews/emptyView.tmpl"),
        EmptyView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        EmptyView = Marionette.ItemView.extend({
            template: template,
            className: 'create-case-sub-view-empty'
        });
    });
    return EmptyView;
});
